import { LOGO_URL } from '@constants/Validation';
import { Box, Button, Typography } from '@material-ui/core';
import { useAuth } from '@swyft/auth';

export const AccessDeniedErrorPage = () => {
  const { signOut } = useAuth();

  return (
    <Box width='100vw' height='100vh' className='flex justify-center items-center bg-white'>
      <Box width={{ xs: 400, md: 500 }} className='shadow-xl p-16 border rounded'>
        <img src={LOGO_URL} alt='logo-pinelyne' className='mx-auto h-12' />
        <Typography variant='h5' className='text-center my-6'>
          <span>Access Denied</span>
        </Typography>
        <Typography variant='subtitle2' className='text-center'>
          <span>You do not have permission to access the requested resource.</span>
        </Typography>
        <Button
          color='primary'
          variant='contained'
          className='normal-case font-normal w-40 h-12 shadow-none my-8 block mx-auto'
          onClick={signOut}
        >
          <span>Sign Out</span>
        </Button>
      </Box>
    </Box>
  );
};
